import { Component, EventEmitter, forwardRef, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ButtonComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ButtonComponent {
  // @Input() btnType: string = 'default';
  @Input() customClass: string = '';
  @Input() ariaLabel: string | null = null;
  @Input() btnType?: 'default' | 'stroked' | 'icon' | 'icon-bg' | 'no-border' | 'no-btn' | 'cancel' | 'raised' =
    'default';
  @Input() styleType: 'default' | 'rounded' = 'default';
  @Input() full: boolean = false;
  @Input() disabled?: boolean = false;
  @Input() dev: boolean = false;
  @Input() beta: boolean = false;

  @Output() onChangeClick = new EventEmitter();

  click(event: any) {
    if (!this.disabled) this.onChangeClick.emit(event);
  }

  protected readonly customElements = customElements;
}
